import { CLINIC } from "@/lib/api";

export default function Logo({ className = "h-14 w-14", alt = "Manasvi Dental" }) {
  return (
    <picture>
      <source srcSet="/logo.webp" type="image/webp" />
      <img src={CLINIC.logo} alt={alt} className={`${className} object-contain`} loading="eager" />
    </picture>
  );
}
